import { render, staticRenderFns } from "./AIEditorTab.vue?vue&type=template&id=fe1d4c80&scoped=true"
import script from "./AIEditorTab.vue?vue&type=script&lang=js"
export * from "./AIEditorTab.vue?vue&type=script&lang=js"
import style0 from "./AIEditorTab.vue?vue&type=style&index=0&id=fe1d4c80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe1d4c80",
  null
  
)

export default component.exports